import { Colors } from '@/common/colors/colors';
import Loading from '@/common/components/Loading';
import PopUp from '@/common/components/PopUp';
import SelectInput from '@/common/components/SelectInput';
import ActionButton from '@/common/components/buttons/ActionButton';
import SubmitButton from '@/common/components/buttons/SubmitButton';
import { Form } from '../sendAnyMail/SendAnyMail.styled';
import useSendPromoMail from './useSendPromoMail';

const SendPromoMail = ({
	setShowSendPromoMail,
	handleSendPromotionMailTemplate,
	showSendPromoMail,
}) => {
	const hook = useSendPromoMail({
		handleSendPromotionMailTemplate,
		showSendPromoMail,
	});

	return (
		<>
			{hook.isLoading && <Loading />}
			<PopUp setShow={setShowSendPromoMail}>
				<Form
					onSubmit={(e) => {
						e.preventDefault();
						hook.setAccepted(true);
					}}
				>
					<SelectInput
						showLabel={false}
						options={hook.promotions}
						selected={hook.selectedPromotion}
						setSelected={hook.setSelectedPromotion}
					/>
					<SubmitButton style={{ marginBottom: '-30px' }} text={'Send Mail'} />
				</Form>
			</PopUp>
			{hook.accepted && (
				<PopUp setShow={hook.setAccepted}>
					<div>
						<div>
							Are you sure that you want to send{' '}
							{hook.selectedPromotion.label.split('_').slice(1, -1).join('_')}{' '}
							mail?
						</div>
						<div
							style={{
								display: 'flex',
								justifyContent: 'center',
								gap: '20px',
								marginTop: '50px',
							}}
						>
							<ActionButton
								defaultText='No i dont'
								color={Colors.red}
								onClick={() => hook.setAccepted(false)}
							/>
							<ActionButton
								text='Yes i want'
								onClick={() => hook.handleSend(false)}
							/>
						</div>
					</div>
				</PopUp>
			)}
		</>
	);
};

export default SendPromoMail;
